import {useState} from 'react';
import {IonLabel, IonTextarea} from '@ionic/react';
import {useHistory} from 'react-router';
import actions from '../api/ownDeclaration';
import {validateLength} from '../utilis/validateLength';
import UIButton from '../components/UICommon/UIButton';
import UICardHeader from '../components/UICommon/UICardHeader';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import UIModal from '../components/UICommon/UIModal';
import UIStackedInput from '../components/UICommon/UIStackedInput';

const AddTextQuestionPage: React.FC = () => {
  const [questionName, setQuestionName] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [questionErrors, setQuestionErrors] = useState({
    questionName: '',
    title: '',
    content: '',
  });
  const history = useHistory();

  // eslint-disable-next-line max-len
  const desc = 'Här kan du skapa ett fält i hälsodeklarationen där endast text visas för kund. Välj vilken rubrik du vill ha och sedan och fyll den text som kommer visas för kund.';

  const onSubmit = () => {
    const tmpErrors = {
      questionName: validateLength(questionName),
      title: validateLength(title),
      content: validateLength(content),
    };
    setQuestionErrors(tmpErrors);
    const hasErrors = Object.values(tmpErrors).some((error) => error !== '');
    if (!hasErrors) {
      setLoading(true);
      const data = {
        title: questionName,
        type: 'text',
        question_content: [
          {
            name: title,
            text: content,
            order: 0,
          },
        ],
      };
      actions.addNewQuestion(data).then(() => {
        setLoading(false);
        history.push('/egen-deklaration');
      }).catch(() => {
        setLoading(false);
        setError(true);
      });
    }
  };

  return (
    <div className='mt-5 flex h-full pb-10 px-6 flex-col overflow-y-scroll'>
      {loading && <UIModal message='Läser in...'/>}
      <div
        className='text-center py-1 rounded-7 text-xs bg-gray-200 w-20 mb-3 text-navy-primary'>
          Endast text
      </div>
      <UICardHeader
        title='Nytt endast text fält'
        description={desc}
        longer={true}
        padding={false}
      />
      <div className='max-w-[600px] flex flex-col space-y-5'>
        <div>
          <UIStackedInput
            labelText='Namn på fält (detta är endast synligt för dig)'
            text={questionName}
            setText={setQuestionName}
            placeholder='exempel: Läkiningsprocess steg 1'
            textStyle='font-normal'
            style='rounded-md border-neutral-200'
          />
          {questionErrors.questionName.length > 0 && (
            <span className='text-sm text-red-form'>{questionErrors.questionName}</span>
          )}
        </div>
        <div>
          <UIStackedInput
            labelText='Rubrik'
            text={title}
            setText={setTitle}
            placeholder='exempel: Läkiningsprocess'
            textStyle='font-normal'
            style='rounded-md border-neutral-200'
          />
          {questionErrors.title.length > 0 && (
            <span className='text-sm text-red-form'>{questionErrors.title}</span>
          )}
        </div>
        <div className='transparent-bg no-padding flex-grow'>
          <IonLabel
            position="stacked"
            className='text-sm font-Manrope font-normal text-navy-black'
          >Beskrivning</IonLabel>
          <IonTextarea
            placeholder='Vad som ska stå som beskriving...'
            className='border w-full rounded text-sm h-full textarea-c'
            value={content}
            onIonChange={(e) => setContent(e.detail.value!)}
          ></IonTextarea>
          {questionErrors.content.length > 0 && (
            <span className='text-sm text-red-form'>{questionErrors.content}</span>
          )}
        </div>
        <div className='flex w-full justify-center md:justify-end py-10'>
          <UIButton type='full' style='round-10' onClick={onSubmit} text='Spara som färdig'/>
        </div>
        {error && <UIErrorIndicator />}
      </div>
    </div>
  );
};

export default AddTextQuestionPage;
